var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScalableFromTheStartup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.7 150.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-3,.cls-4,.cls-2,.cls-5,.cls-6,.cls-7{stroke:#fff;}.cls-3,.cls-4,.cls-6,.cls-7{fill:none;}.cls-3,.cls-6,.cls-7{stroke-miterlimit:10;}.cls-4,.cls-2,.cls-5{stroke-linecap:round;stroke-linejoin:round;}.cls-5{fill:#7da2fe;}.cls-5,.cls-6{stroke-width:2px;}.cls-7{stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.52,
    y: 40.06,
    width: 10.87,
    height: 9.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.45,
    y: 49.55,
    width: 19.02,
    height: 4.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.96,
    y: 23.88,
    width: 8.45,
    height: 4.18,
    transform: "translate(46.37 51.94) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 9.28,
    y: 119.58,
    width: 133.14,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1,
    y: 128.55,
    width: 149.7,
    height: 21.41
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 20.04,
    y1: 94.04,
    x2: 62.33,
    y2: 94.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 20.04,
    y1: 75.16,
    x2: 62.33,
    y2: 75.16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 22.11,
    y1: 75.16,
    x2: 60.26,
    y2: 94.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 22.11,
    y1: 94.04,
    x2: 60.26,
    y2: 75.16
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 20.04,
    y1: 75.16,
    x2: 62.33,
    y2: 75.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 20.04,
    y1: 56.29,
    x2: 62.33,
    y2: 56.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 22.11,
    y1: 56.29,
    x2: 60.26,
    y2: 75.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 22.11,
    y1: 75.16,
    x2: 60.26,
    y2: 56.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 20.04,
    y1: 112.92,
    x2: 62.33,
    y2: 112.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 20.04,
    y1: 94.04,
    x2: 62.33,
    y2: 94.04
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 22.11,
    y1: 94.04,
    x2: 60.26,
    y2: 112.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 22.11,
    y1: 112.92,
    x2: 60.26,
    y2: 94.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 22.02,
    y1: 50.19,
    x2: 22.02,
    y2: 119.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 60.35,
    y1: 50.19,
    x2: 60.35,
    y2: 119.58
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 90.15,
    y1: 75.16,
    x2: 128.3,
    y2: 94.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 90.15,
    y1: 94.04,
    x2: 128.3,
    y2: 75.16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 90.15,
    y1: 56.29,
    x2: 128.3,
    y2: 75.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 90.15,
    y1: 75.16,
    x2: 128.3,
    y2: 56.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 90.15,
    y1: 94.04,
    x2: 128.3,
    y2: 112.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 90.15,
    y1: 112.92,
    x2: 128.3,
    y2: 94.04
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 90.06,
    y1: 50.19,
    x2: 90.06,
    y2: 119.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 128.39,
    y1: 50.19,
    x2: 128.39,
    y2: 119.58
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 60.93,
    y1: 68.35,
    x2: 60.93,
    y2: 75.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 65.69,
    y1: 68.35,
    x2: 65.69,
    y2: 75.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 70.45,
    y1: 68.35,
    x2: 70.45,
    y2: 75.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.21,
    y1: 68.35,
    x2: 75.21,
    y2: 75.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 79.96,
    y1: 68.35,
    x2: 79.96,
    y2: 75.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 84.72,
    y1: 68.35,
    x2: 84.72,
    y2: 75.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 89.48,
    y1: 68.35,
    x2: 89.48,
    y2: 75.16
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 59.55,
    y1: 75.16,
    x2: 90.86,
    y2: 75.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 59.55,
    y1: 68.58,
    x2: 90.86,
    y2: 68.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 60.93,
    y1: 87.23,
    x2: 60.93,
    y2: 94.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 65.69,
    y1: 87.23,
    x2: 65.69,
    y2: 94.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 70.45,
    y1: 87.23,
    x2: 70.45,
    y2: 94.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.21,
    y1: 87.23,
    x2: 75.21,
    y2: 94.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 79.96,
    y1: 87.23,
    x2: 79.96,
    y2: 94.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 84.72,
    y1: 87.23,
    x2: 84.72,
    y2: 94.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 89.48,
    y1: 87.23,
    x2: 89.48,
    y2: 94.04
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 59.55,
    y1: 94.04,
    x2: 90.86,
    y2: 94.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 59.55,
    y1: 87.46,
    x2: 90.86,
    y2: 87.46
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 88.08,
    y1: 75.16,
    x2: 130.37,
    y2: 75.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 88.08,
    y1: 56.29,
    x2: 130.37,
    y2: 56.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 88.08,
    y1: 112.92,
    x2: 130.37,
    y2: 112.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 88.08,
    y1: 94.04,
    x2: 130.37,
    y2: 94.04
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127.45 23.87 45.62 23.87 49.3 19.54 124.28 19.54 127.45 23.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "38.6 23.87 18.16 23.87 21.33 19.54 35.09 19.54 38.6 23.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 48.49,
    y1: 23.87,
    x2: 29.71,
    y2: 23.87
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "43.75 23.87 39.64 23.87 39.64 40.06 43.65 40.06 43.75 23.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "43.75 23.87 39.64 23.87 41.39 .5 42.56 .5 43.75 23.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 23.75,
    y1: 19.07,
    x2: 41.39,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 42.56,
    y1: 0.5,
    x2: 108.9,
    y2: 19.54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "113.63 21.7 110.71 30.65 107.17 21.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 110.71,
    cy: 30.65,
    r: 1.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "92.13 45.12 110.71 36.5 127.73 45.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.49,
    y: 44.26,
    width: 40.06,
    height: 2.47,
    transform: "translate(2.74 -6.16) rotate(3.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.7,35.98c.26,.26,.61,.41,1,.41,.78,0,1.42-.63,1.42-1.42s-.63-1.42-1.42-1.42v-1.61"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalableFromTheStartup);
export default __webpack_public_path__ + "static/media/scalable-from-the-startup.559c06d62598d2918ec3b62fa293b061.svg";
export { ForwardRef as ReactComponent };